/* ============================================================
   gix.domains — CART DRAWER TEMPLATE  (shared global chrome)
   ------------------------------------------------------------
   The header (top bar + nav) and footer are now STATIC markup in
   each page's HTML — edit them directly per page (styling still
   follows gix-tokens.css). Only the slide-in CART DRAWER is shared
   from here: it's auto-injected once at body level and opened by
   any header cart trigger.

   Load this BEFORE the cart-logic / layout scripts.
   ============================================================ */
(function () {
  "use strict";

  var TEMPLATES = {
    /* ---- CART DRAWER (slide-in panel; opened by any .cart trigger) ---- */
    cart:
      '<div class="gcart" data-gix-cart aria-hidden="true">' +
        '<div class="gcart__scrim" data-gcart-close></div>' +
        '<aside class="gcart__panel" role="dialog" aria-modal="true" aria-label="Your setup">' +
          '<header class="gcart__head">' +
            '<span class="gcart__title">Your setup</span>' +
            '<button class="gcart__close" type="button" data-gcart-close aria-label="Close cart">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
            '</button>' +
          '</header>' +
          '<div class="gcart__body">' +
            '<div class="gcart__empty">' +
              '<span class="gcart__empty-node" aria-hidden="true"></span>' +
              '<p class="gcart__empty-t">Your cart is empty</p>' +
              '<span class="gcart__empty-s">Add a setup or service and it will appear here, ready to configure.</span>' +
            '</div>' +
          '</div>' +
          '<footer class="gcart__foot">' +
            '<div class="gcart__row"><span>Subtotal</span><b class="gcart__total">$0.00</b></div>' +
            '<a class="btn btn--primary gcart__checkout" href="#">Continue to checkout' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>' +
            '</a>' +
            '<span class="gcart__note">Taxes &amp; setup details confirmed at checkout.</span>' +
          '</footer>' +
        '</aside>' +
      '</div>'
  };

  /* expose so other scripts/settings can read the same source */
  window.GIX_TEMPLATES = TEMPLATES;

  /* Generic mount filler — still honours any <div data-gix-mount="…"> slots
     (none ship by default now that header/footer are static, but kept so a
     page can opt into a shared partial later). */
  function inject() {
    document.querySelectorAll("[data-gix-mount]").forEach(function (slot) {
      var key = slot.getAttribute("data-gix-mount");
      if (!TEMPLATES[key] || slot.getAttribute("data-gix-filled") === "1") return;
      slot.innerHTML = TEMPLATES[key];
      slot.setAttribute("data-gix-filled", "1");
    });
  }
  inject();
  window.GIX_MOUNT_CHROME = inject;

  /* ---- CART DRAWER: auto-inject once + wire open/close ---- */
  function ensureCart() {
    var c = document.querySelector("[data-gix-cart]");
    if (c) return c;
    /* Mount at BODY level inside a token-scope wrapper — NOT inside .page.
       .page is scaled with CSS `zoom` on tablet/mobile, and a position:fixed
       slide-in panel trapped in a zoomed/transformed subtree mis-positions and
       its transform transition stalls. A display:contents .page--s3 wrapper
       keeps all the --surface/--ink token vars resolving (they inherit through
       display:contents) while the drawer escapes the zoom context. */
    var pg = document.querySelector(".page--s3");
    var scope = document.createElement("div");
    scope.className = "page--s3 gcart-scope";
    scope.setAttribute("data-theme", (pg && pg.getAttribute("data-theme")) || "light");
    scope.style.display = "contents";
    /* Font tokens (--display/--mono/--body) are declared INLINE on the real
       .page--s3 element, not via a stylesheet rule, so a second .page--s3
       (this scope, living at body level) doesn't pick them up and the cart
       falls back to Times. Copy every inline custom property across so the
       drawer inherits the exact same type + token values as the page. */
    if (pg) {
      var cs = getComputedStyle(pg);
      ["--display", "--mono", "--body"].forEach(function (v) {
        var val = cs.getPropertyValue(v);
        if (val) scope.style.setProperty(v, val.trim());
      });
      if (pg.style) {
        for (var i = 0; i < pg.style.length; i++) {
          var prop = pg.style[i];
          if (prop.indexOf("--") === 0) scope.style.setProperty(prop, pg.style.getPropertyValue(prop));
        }
      }
      if (cs.fontFamily) scope.style.fontFamily = cs.fontFamily;
    }
    var wrap = document.createElement("div");
    wrap.innerHTML = TEMPLATES.cart.trim();
    c = wrap.firstChild;
    scope.appendChild(c);
    document.body.appendChild(scope);
    return c;
  }
  function openCart() {
    var c = ensureCart(); if (!c) return;
    c.setAttribute("aria-hidden", "false");
    c.classList.add("gcart--open");
    document.documentElement.style.overflow = "hidden";
  }
  function closeCart() {
    var c = document.querySelector("[data-gix-cart]"); if (!c) return;
    c.classList.remove("gcart--open"); c.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
  }
  ensureCart();
  document.addEventListener("click", function (e) {
    var trig = e.target.closest && e.target.closest(".cart");
    if (trig) { e.preventDefault(); openCart(); return; }
    if (e.target.closest && e.target.closest("[data-gcart-close]")) { e.preventDefault(); closeCart(); }
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeCart(); });
  window.GIX_CART = { open: openCart, close: closeCart };
})();
